<template>
 <v-container>
 <v-card style="border-radius: 8px;">
     <v-container>
         <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Template</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    item-text="name"  
                    item-value="id"                   
                    :items="cMessages"
                    label="Select message template"
                    v-model="docId"                    
                ></v-select>
             </v-flex>
         </v-layout>
        <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Message tag</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    item-text="tag" 
                    :items="MessageTags"
                    label="Select message tag"
                    v-model="messageTag"                    
                    return-object
                ></v-select>
             </v-flex>
             <v-flex  color="grey--text" xs5>
                    <div>{{messageTag.description}}</div>
            </v-flex>
         </v-layout>
        <!-- <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Broadcast to label</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    class="ma-0 pa-0"
                    :items="labels"
                    label="Select label"
                    v-model="label"                    
                ></v-select>
             </v-flex>
         </v-layout> -->
        <!-- <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">User mode</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-radio-group v-model="userMode">
                    <v-radio
                        label="Single User"
                        value="single"
                    ></v-radio>
                     <v-radio
                        label="Multiple Users"
                        value="multiple"
                    ></v-radio>
                </v-radio-group>
             </v-flex>
         </v-layout> -->
        <v-layout v-if="userMode == 'single'">
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">User search by</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs2>
                <v-radio-group v-model="searchby">
                     <v-radio
                        label="User Name"
                        value="username"
                    ></v-radio>
                    <v-radio
                        label="User ID"
                        value="userid"
                    ></v-radio>
                </v-radio-group>
             </v-flex>
             <v-flex xs4>
                <v-text-field
                    v-if="searchby == 'userid'"
                    v-model="uservalue"
                    label="User id"
                    hint="Get the user details from users menu"
                    append-icon="search"
                    :error="validuser"
                    @click:append="validateuser"
                ></v-text-field>
                <v-text-field
                    v-if="searchby == 'username'"
                    v-model="uservalue"
                    label="User name"
                    hint="First name space last name"
                    append-icon="search"
                    :error="validuser"
                    @click:append="validateuser"
                ></v-text-field>
             </v-flex>
        </v-layout>
        <v-layout v-if="userMode == 'multiple'">
             <v-flex xs3>
                <v-card-title>
                    <h2 class="font-weight-regular">User conditions</h2>
                </v-card-title>
             </v-flex>
            <v-flex xs3>
                <v-select  
                    dense                
                    :items="cUserVars"
                    label="Select user var"
                    v-model="uservar"                    
                ></v-select>
             </v-flex>
            <v-flex xs3>
                <v-select
                    dense                  
                    :items="userconditions"
                    label="Select the condition"
                    v-model="usercondition"                    
                ></v-select>
             </v-flex>
             <v-flex xs3>
                <v-text-field
                    dense
                    label="Enter the value"
                    v-model="userconditionvalue"                    
                ></v-text-field>
                <v-btn @click="addFilter">Add</v-btn>
             </v-flex>
         </v-layout>  
         <v-layout v-if="userMode == 'multiple' && filters.length !=0" >
             <v-flex xs3>
             </v-flex>
             <v-flex xs9>
                <v-card flat class="blue-grey lighten-5" style="border-radius: 8px;">
                    <v-card-title v-for="(filter,index) in filters" :key="index">
                        <v-layout>
                            <v-flex  xs4>
                                {{filter.uservar}}
                            </v-flex>
                            <v-flex  xs4>
                                {{filter.usercondition}}
                            </v-flex>
                            <v-flex  xs4>
                                {{filter.userconditionvalue}}
                            </v-flex>
                        </v-layout>    
                        <v-spacer></v-spacer> 
                            <v-btn icon small @click="deleteFilter(index)"><v-icon>clear</v-icon></v-btn>   
                    </v-card-title>
                    <v-card-title>
                        <v-layout>
                            <v-flex  xs4>
                                Filtered users count: {{filtereduserscount}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </v-card>
             </v-flex>

         </v-layout>                
         <v-layout>
             <v-flex xs3>
             </v-flex>             
             <v-flex xs3 class="mt-2 ml-5" v-if="schedule == 'no'">
                <v-card class="mt-4 blue lighten-5" style="border-radius: 8px;" v-if="userMode == 'single'">
                    <v-btn  @click="broadcastmessage" class="mt-2" block flat >Send Message</v-btn>
                </v-card>
                <v-card class="mt-4 blue lighten-5" style="border-radius: 8px;" v-if="userMode == 'multiple'">
                    <v-btn  @click="broadcastgroupmessage" class="mt-2" block flat >Send Message</v-btn>
                </v-card>
             </v-flex>
         </v-layout>       
    </v-container>
 </v-card>
</v-container>    
</template>

<script>
import {db} from '@/plugins/firebase.js'; 
import {timeZones} from '@/plugins/timezones.js'; 
Date.prototype.toIsoString = function() {
    var tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            var norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
}
export default {
    data(){
        return{
            docId:null,
            userMode:'single',
            searchby:'username',
            validuser:false,
            uservalue:null,
            uservar:null,
            usercondition:null,
            userconditions:['Is','Contains','Is Not','Not Contains'],
            userconditionvalue:null,
            filters:[],
            psid:null,
            filteredusers:[],
            filtereduserscount:null,
            MessageTags:[{"tag":"NON_PROMOTIONAL_SUBSCRIPTION","description":"The non_promotional_subscription tag can be used to send non-promotional messages under the News, Productivity, and Personal Trackers categories described in the Messenger Platform's subscription messaging policy. You can apply for access to use this tag under the Page Settings > Messenger Platform. Use Cases: News. Productivity. Personal Trackers."},
                            {"tag":"CONFIRMED_EVENT_UPDATE","description":"Send the user reminders or updates for an event they have registered for (e.g., RSVP'ed, purchased tickets). This tag may be used for upcoming events and events in progress."},
                            {"tag":"POST_PURCHASE_UPDATE","description":"Notify the user of an update on a recent purchase."},
                            {"tag":"ACCOUNT_UPDATE","description":"Notify the user of a non-recurring change to their application or account."},
                            {"tag":"HUMAN_AGENT","description":"Allows human agents to respond to user inquiries. Messages can be sent within 7 days after a user message."}],
            messageTag:{"tag":"NON_PROMOTIONAL_SUBSCRIPTION","description":"The non_promotional_subscription tag can be used to send non-promotional messages under the News, Productivity, and Personal Trackers categories described in the Messenger Platform's subscription messaging policy. You can apply for access to use this tag under the Page Settings > Messenger Platform. Use Cases: News. Productivity. Personal Trackers."},
            label:null,
            notifyType:"REGULAR",
            schedule:"no",
            errornote:"error message",                  
            date: new Date().toIsoString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            time: null,
            modal2: false,
            timezoneslist:timeZones,
            timezone:null
        }
    },
    computed:{
        cMessages(){
            if(this.$store.state.bTemplateNames.length > 0)
            {
                return this.$store.state.bTemplateNames
            }
            else {
                return []
            }
            
        },
        cMessageTags(){

             return this.$store.state.bmessageTags
        },
        cUserVars(){
            return this.$store.state.uservars
        },
        cusers(){
            return this.$store.state.pageusers
        }
    },
    methods:{
        addFilter(){
            if (this.uservar != null && this.usercondition != null && this.userconditionvalue != null)
            {
                this.filters.push({'uservar':this.uservar,'usercondition':this.usercondition,'userconditionvalue':this.userconditionvalue})
                
                let fusers = []
                if (this.filteredusers.length == 0){
                    fusers = this.cusers
                }
                else{
                    fusers = this.filteredusers
                }
                let filteredUsers
                if (this.usercondition == 'Is'){
                    filteredUsers = fusers.filter(filteruser => filteruser.vars[this.uservar] == this.userconditionvalue )
                }
                else if (this.usercondition == 'Contains'){
                    filteredUsers = fusers.filter(filteruser => filteruser.vars[this.uservar].includes(this.userconditionvalue) )
                }
                this.uservar = null
                this.usercondition = null
                this.userconditionvalue = null                
                console.log(filteredUsers)
                this.filteredusers = filteredUsers
                this.filtereduserscount = filteredUsers.length
            }
        },
        deleteFilter(index){
            this.filteredusers = []
            console.log(this.filters.length)
            for ( let i in 1){
                console.log('FIRST')
                if(i != index){
                    console.log('SECOND')
                this.uservar = this.filters[i].uservar
                this.usercondition = this.filters[i].usercondition
                this.userconditionvalue = this.filters[i].userconditionvalue
                let fusers = []
                if (this.filteredusers.length == 0){
                    fusers = this.cusers
                }
                else{
                    fusers = this.filteredusers
                }
                let filteredUsers
                if (this.usercondition == 'Is'){
                    filteredUsers = fusers.filter(filteruser => filteruser.vars[this.uservar] == this.userconditionvalue )
                }
                else if (this.usercondition == 'Contains'){
                    filteredUsers = fusers.filter(filteruser => filteruser.vars[this.uservar].includes(this.userconditionvalue) )
                }
                this.uservar = null
                this.usercondition = null
                this.userconditionvalue = null                
                console.log(filteredUsers)
                this.filteredusers = filteredUsers
                this.filtereduserscount = filteredUsers.length
                }
            }
            this.filters.splice(index,1)
        },
        validateuser(){
            if(this.searchby == 'userid'){
                let validuser = this.cusers.filter(users => users.userid == this.uservalue)
                if (validuser.length != 0){
                    this.psid = validuser[0].userid
                    this.validuser = false
                    console.log(this.psid)
                }
                else{
                    this.validuser = true
                }
            }
            else if (this.searchby == 'username'){
                let validuser = this.cusers.filter(users => users.username.toUpperCase() == this.uservalue.toUpperCase())
                if (validuser.length != 0){
                    this.psid = validuser[0].userid
                    this.validuser = false
                    console.log(this.psid)
                }
                else{
                    this.validuser = true
                }
            }
        },
        broadcastmessage(){
            let messages = null
            let psid = this.psid
            let mtag = this.messageTag.tag
            console.log(this.docId)
            console.log(this.messageTag)
            // console.log(this.notifyType)
            // console.log(this.schedule)
            let pageid = this.$store.state.selectedPage
            let accessToken = this.$store.state.pageDetails.accessToken
            console.log(accessToken)
            let messageId = null
            var getbMessage = db.doc('pages/'+pageid+'/broadcast/'+this.docId).get()
                .then(doc => {
                    if (!doc.exists) {
                    console.log('No such document!');
                    } else {
                        messages = doc.data().messages
                        console.log(messages)
                            let counterLength = messages.length
                            let i=0
                            sendmsg();
                            function sendmsg(){
                                console.log(messages[i])
                                FB.api(
                                    //"/"+pageid+"/messages?access_token=" +accessToken,
                                    "/me/messages?access_token="+accessToken,
                                    'POST',
                                    {    
                                        "recipient": { 
                                                "id": psid
                                            },
                                        "messaging_type": "MESSAGE_TAG",
                                        "tag": mtag,
                                        "message": messages[i].message,
                                    },
                                    function (response) {
                                        console.log(response)
                                });
                            i++
                            if(i < counterLength){
                               setTimeout(sendmsg,1000);
                            }
                            }
                    }
                })
                .catch(err => {
                    console.log('Error getting document', err);
                });   
        },
        broadcastgroupmessage(){

        }
    }
}
</script>
